import { AriaTablist } from "app/components/aria_tablist"
import { logCustomDatadogAction } from "app/scripts/shared_setup"
import detectPlatform from "shared/detect_platform"

export default function FeaturedAppletsModule() {
  const tablist = document.querySelector<HTMLElement>(".featured-tabs")
  const tabs = Array.from(document.querySelectorAll<HTMLButtonElement>(".featured-tab"))
  const panels = Array.from(document.querySelectorAll<HTMLDivElement>(".featured-category-panel"))

  const impressionObserver = new IntersectionObserver(
    entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
          const card = entry.target as HTMLLIElement

          if (card.dataset.impressionTracked === "false") {
            const appletId = card.dataset.appletId
            const categoryName = card.dataset.category

            logCustomDatadogAction("featured_applets_card_impression", {
              applet_id: appletId,
              category_name: categoryName,
              platform: detectPlatform(),
            })

            card.dataset.impressionTracked = "true"
          }
        }
      })
    },
    { threshold: 0.5 },
  )

  const wireCards = (root: Document | HTMLElement) => {
    root.querySelectorAll<HTMLLIElement>(".featured-applet-card").forEach(card => {
      impressionObserver.observe(card)

      card.addEventListener("click", () => {
        logCustomDatadogAction("featured_applets_card_clicked", {
          applet_id: card.dataset.appletId,
          category_name: card.dataset.category,
          platform: detectPlatform(),
        })
      })
    })
  }

  // Inactive tabs ship their cards in a <template>, so they cost nothing until picked. Runs
  // inside the activation handler, before the browser gets to paint the now-visible panel.
  const materialize = (panel: HTMLDivElement) => {
    const template = panel.querySelector("template")
    if (!template) return

    panel.appendChild(template.content)
    template.remove()
    wireCards(panel)
  }

  AriaTablist({
    tablist,
    tabs,
    panels,
    panelMatches: (tab, panel) => panel.dataset.category === tab.dataset.category,
    onActivate: tab => {
      const panel = panels.find(p => p.dataset.category === tab.dataset.category)
      if (panel) materialize(panel)

      logCustomDatadogAction("featured_applets_tab_clicked", { category_name: tab.dataset.category })
    },
  })

  wireCards(document)

  const ctaButton = document.querySelector<HTMLAnchorElement>(".featured-cta")
  if (ctaButton) {
    ctaButton.addEventListener("click", () => {
      const activeTab = document.querySelector<HTMLButtonElement>(".featured-tab.active")
      const categoryName = activeTab ? activeTab.dataset.category : "unknown"

      logCustomDatadogAction("featured_applets_cta_clicked", { category_name: categoryName })
    })
  }
}
